import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import imgCamelLogo from '../assets/images/main-logo-white.png';
import "./Bye.scss";

class ByePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.isAuthenticated) {
      props.history.goBack();
    }

    return null;
  }

  render() {
    return (
      !this.props.isAuthenticated ? <div className="bye-page">
        <div className="modal-box">
          <div className="modal-header"><img src={imgCamelLogo} alt="logo" /></div>
          <div className="modal-content">
            <div className="message">
              <div>You are signed out</div>
              <div>Bye bye and come back soon!</div>
            </div>
            <Link to="/login"><Button variant="danger" size="sm">LOGIN</Button></Link>
          </div>
        </div>
      </div>
      : ''
    )
  }
}

export default ByePage;
